<template>
    <div class="row">
      <!-- General Top Bar -->
      <!-- <general-top-bar :title="$t('pages.invoice')"></general-top-bar> -->
      <!-- End General Top Bar -->
      <div class="box-container row tabs-dispatch">
        <div
          v-for="(route, index) in invoiceRoutes"
          :key="route.key"
          class="col-md-4"
        >
          <router-link
            :to="route.path"
            class="box"
            :style="{ backgroundColor: getBoxColor(index) }"
          >
            <div class="title">{{ $t('invoice.' + route.key) }}</div>
            <div class="image">
              <img :src="getImageForRoute(route.key)" :alt="'Image for ' + route.key" />
            </div>
          </router-link>
        </div>
      </div>
    </div>
</template>

  <script>
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'

  export default {
    components: {
      // GeneralTopBar
    },
    data () {
      return {
        invoiceRoutes: [
          { path: '/invoice-tabs/sidebar?tabIndex=0', key: 'invoices' },
          { path: '/invoice-tabs/sidebar?tabIndex=1', key: 'proforma' },
          { path: '/invoice-tabs/sidebar?tabIndex=2', key: 'reports' },
          { path: '/invoice-tabs/sidebar?tabIndex=3', key: 'settings' }
        ]
      }
    },
    methods: {
      getImageForRoute (routeKey) {
        const images = {
          'invoices': 'static/img/dispatch-settings.png',
          'proforma': 'static/img/dispatch-settings.png',
          'reports': 'static/img/dispatch-settings.png',
          'settings': 'static/img/dispatch-settings.png'
        }
        return images[routeKey] || 'static/img/default.jpg'
      },
      getBoxColor (index) {
        const colors = [
          '#3AB7CD',
          '#FF6B6B',
          '#674BD2',
          '#FF6B6B'
        ]
        return colors[index] || '#FFFFFF' // Default color
      }
    }
  }
  </script>

  <style scoped>
  .box-container.row {
    max-width: 1300px;
    margin-top: 30px;
    margin: auto;
  }
  .tabs-dispatch {
    margin-top: 40px;
  }
  .box-container.row .image {
    position: absolute;
    bottom: 0;
  }
  .box-container .col-md-4 {
    width: 24.333333%;
  }
  .box {
    position: relative;
    margin-bottom: 30px;
    text-align: center;
    display: block;
    text-decoration: none;
    color: inherit;
    border-radius: 30px;
    width: 280px;
    height: 280px;
  }
  .title {
    margin-bottom: 8px;
    padding: 30px 0px;
    color: #fff;
    font-size: 20px;
    font-weight: 500;
  }
  .image img {
    width: 100%;
    height: auto;
    max-width: 100%;
    display: block;
    margin: 0 auto 0px;
    border-top-right-radius: 50px;
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
  </style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Invoice/InvoiceTabs.vue